import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { ExternalStateT } from "./use-external-state";
import React from "react";

import { css } from "@emotion/react";

import { AttributeSection } from "./ShowRow";
import { PCPDifferencesModeSwitch } from "./PCPDifferencesModeSwitch";
import { gridStyles } from "../styles";

export const AttributeDisplayer: ReactTFC<{
  selectedProductKeys: Array<string>;
  sections: ExternalStateT["sections"];
  mode: "all" | "differences-only";
  toggleMode: () => void;
  showOnlyDifferencesLabel: React.ReactNode;
}> = props => {
  return (
    <React.Fragment>
      {props.selectedProductKeys.length >= 2 && (
        <PCPDifferencesModeSwitch
          selectedProductsCount={props.selectedProductKeys.length}
          mode={props.mode}
          toggleMode={props.toggleMode}
          showOnlyDifferencesLabel={props.showOnlyDifferencesLabel}
        />
      )}

      {props.sections.map((section, idx) => {
        return (
          <div
            className={`selected-${props.selectedProductKeys.length}`}
            css={css`
              ${gridStyles};

              margin-bottom: 40px;
            `}
            key={idx}
          >
            <AttributeSection {...section} selectedProductKeys={props.selectedProductKeys} mode={props.mode} />
          </div>
        );
      })}
    </React.Fragment>
  );
};
